/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import debug from "./constants/Debug";

export const downloadFile = (filename, content) => {
  // convert content to text
  const blob = new Blob([content], { type: 'text/plain' });

  // prepare invisible link
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.download = filename;
  link.href = url;

  // add link to DOM and click it
  document.body.appendChild(link);
  link.click();

  // remove link from DOM
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadArrayAsCSV = (filename, data) => {
  // verify data is an array
  if (!Array.isArray(data)) {
    debug.warn("Invalid CSV data: " + data);
    return;
  }

  // convert to .csv format
  const csvRows = data.map(row => row.map(cell => cell == null ? "" : `"${cell}"`).join(","));

  // download file
  downloadFile(filename, csvRows.join("\n"));
};

export const getFileExtension = (filename) => {
  // handle null
  if (filename == null) {
    return null;
  }

  // split filename string into substrings
  const split = filename.split(".");

  // handle invalid file
  if (split.length < 2) {
    return null;
  }

  // return the last element of the split
  const extension = split[split.length - 1];

  // handle file extension alternative names
  switch (extension) {
    case "ogv":
      return "ogg";
    default:
      return extension;
  }
};

export const validateFileSize = (fileList, maxSize = 1048576 /* default max is 1MB */) => {
  const file = fileList?.[0];
  return file == null || file.size < maxSize;
};

export const getFileSizeString = (fileSize) => {
  // handle invalid inupt
  if (isNaN(fileSize)) {
    return null;
  }
  
  // constants
  const byteOrders = [ "B", "KB", "MB", "GB", "TB" ];
  let orderIndex = 0;
  let currentSize = fileSize;

  // iterate over size orders
  while (currentSize > 1024 && orderIndex < byteOrders.length) {
    orderIndex += 1;
    currentSize /= 1024;
  }

  // return size string
  const byteOrder = byteOrders[orderIndex];
  return `${Math.round(currentSize)} ${byteOrder}`;
};

export const formatBytes = (bytes) => {
  if (bytes == null) {
    return null;
  }
  
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
